import React from 'react';
import styled from 'styled-components';
import {Button, Dropdown} from 'components/antd';
import ColumnPopover from 'components/Ui/ColumnPopover';
import {ArrowDown, Eye} from 'components/Ui/Icon';

export default () => {
  return (
    <Container>
      <Dropdown
        placement="bottomLeft"
        trigger={['click']}
        overlay={<ColumnPopover />}>
        <Button type="ghost">
          <div className="items-center mt-1 mr-2">
            <Eye />
          </div>
          表示項目初期設定 <ArrowDown />
        </Button>
      </Dropdown>
    </Container>
  );
};

const Container = styled.div`
  .ant-btn-ghost {
    display: flex;
    align-items: center;
    border: 1px solid #bdc4cb;
    border-radius: 4px;
    color: #495058;
    font-weight: 700;
    padding: 5.6px 10px;

    svg {
      width: 14px;
      height: 14px;
      margin-left: 8px;
    }
  }
`;
